import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { OtherIndividualInfo } from '../../../../domain/person';
import { ConfirmationDlg } from '../../../../general/dialogs/confirmation-dlg';
import { removeOtherIndividual } from '../../reducers/other-individuals.reducer';

type Props = {
  onClose: () => void;
  context: {
    uiId: OtherIndividualInfo['uiId'];
  };
};

const ConfirmRemoveIndividualDlg: React.FC<Props> = ({ onClose, context: { uiId } }: Props) => {
  const dispatch = useDispatch();
  const handleConfirm = useCallback(() => {
    dispatch(removeOtherIndividual(uiId));
    onClose();
  }, [dispatch, onClose, uiId]);

  return (
    <ConfirmationDlg
      onClose={onClose}
      onCancel={onClose}
      content={
        <>
          Are you sure you want to remove this
          <br /> individual from the application?
        </>
      }
      title="Remove Individual?"
      confirmLabel="Yes, Remove"
      onConfirm={handleConfirm}
    />
  );
};

export { ConfirmRemoveIndividualDlg };
